import axios from "axios";
import { CollectionEventSummaryModel } from "@/api/CollectionEvents";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type ListCollectionEventsRequest = {
  eventDate: Date;
  boundary?: number[];
};

export type ListCollectionEventsResponse = {
  collectionEvents: CollectionEventSummaryModel[];
};

export const listCollectionEvents = async (request: ListCollectionEventsRequest) => {
  const response = await executeApiRequest(
    () =>
      axios.post<ListCollectionEventsResponse>("/collectionevents", {
        eventDate: request.eventDate,
        boundary: request.boundary
      }),
    false
  );

  return response?.data;
};
